export default "__VITE_ASSET__7ht_rWW___"